import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../layout";
import ContactUs from "../pages/Contactus";
import SliderBanner from "../components/Banner/SliderBanner";
import Feature from "../components/Feature/Feature";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import RefundPolicy from "../pages/RefundPolicy";
import ScrollToTop from "../components/ScrollToTop";
import SignUpView2 from "../users/pages/Auth/CompleteSingUp";
import PricingPage from "../components/Pricing/PricingPage";
import PaymentPage from "../components/Pricing/PaymentPage";
import { PasswordRecover } from "../users/pages/Auth/userForgotPass";
import ForgotVOtpPage from "../users/pages/Auth/userForgotPassOtp";
import { PasswordUpdateViewPage } from "../users/pages/Auth/userPassUpdate";
import AboutUs from "../pages/AboutPage/AboutUs";
import Services from "../pages/ServicesPage/Services";
import PricingSignIn from "../users/pages/Auth/PricingSignIn";
import { OtpPageView } from "../users/pages/Auth/userSignupOtp";
import SignUpView from "../users/pages/Auth/userSignup";
import CreateProfileViewPage from "../users/pages/Auth/userProfileUpdate";
import HomeAbout from "../components/Home-About/HomeAbout";
import NotFoundPage from "../users/pages/NotFoundPage";
import LogoCarousel from "../components/LogoCarousel/LogoCarousel";

export default function MainRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Routes with Layout */}
        <Route
          path="/"
          element={
            <Layout>
              <>
                <SliderBanner />
                <HomeAbout />
                <Feature />
                <LogoCarousel />
              </>
            </Layout>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          }
        />
        <Route
          path="/pricing-signup"
          element={
            <Layout>
              <SignUpView2 />
            </Layout>
          }
        />
        <Route
          path="/terms-of-service"
          element={
            <Layout>
              <TermsOfService />
            </Layout>
          }
        />
        <Route
          path="/pricing"
          element={
            <Layout>
              <PricingPage />
            </Layout>
          }
        />
        <Route
          path="/refund-policy"
          element={
            <Layout>
              <RefundPolicy />
            </Layout>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <ContactUs />
            </Layout>
          }
        />
        {/* <Route
          path="/sitemap"
          element={
            <Layout>
              <sitemap />
            </Layout>
          }
        /> */}
        <Route
          path="/service"
          element={
            <Layout>
              <Services />
            </Layout>
          }
        />
        <Route
          path="/about"
          element={
            <Layout>
              <AboutUs />
            </Layout>
          }
        />
        <Route
          path="/payment"
          element={
            <Layout>
              <PaymentPage />
            </Layout>
          }
        />

        {/* Routes without Layout */}
        <Route
          path="/pricing-signin"
          element={
            <Layout>
              <PricingSignIn />
            </Layout>
          }
        />
        <Route
          path="/signup"
          element={
            <Layout>
              <SignUpView />
            </Layout>
          }
        />
        <Route
          path="/get-otp"
          element={
            <Layout>
              <OtpPageView />
            </Layout>
          }
        />
        <Route
          path="/create-profile"
          element={
            <Layout>
              <CreateProfileViewPage />
            </Layout>
          }
        />
        <Route
          path="/recoverpassword"
          element={
            <Layout>
              <PasswordRecover />
            </Layout>
          }
        />
        <Route
          path="/Verifyotp"
          element={
            <Layout>
              <ForgotVOtpPage />
            </Layout>
          }
        />
        <Route
          path="/Updatepassword"
          element={
            <Layout>
              <PasswordUpdateViewPage />
            </Layout>
          }
        />
        <Route
          path="*"
          element={
            <Layout>
              <NotFoundPage />
            </Layout>
          }
        />
      </Routes>
    </>
  );
}
